import {
  Box,
  Container,
  Heading,
  ListItem,
  Text,
  UnorderedList,
  useColorModeValue,
  VStack,
} from '@chakra-ui/react'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import { pageTitle } from '../global'

const Vop: React.FC = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900')
  const headingColor = useColorModeValue('purple.600', 'purple.300')

  return (
    <>
      <Helmet>
        <title>{pageTitle('Všeobecné obchodné podmienky')}</title>
        <meta
          name="description"
          content="Prečítajte si fascinujúce články o snoch, snových symboloch a ich významoch. Objavte tajomstvá vášho podvedomia, naučte sa interpretovať sny a pochopte ich vplyv na váš život."
        />
      </Helmet>
      <Box bg={bgColor} minH="100vh">
        <Container maxW="container.xl" py={10}>
          <VStack className="space-y-8">
            <Heading as="h1" size="2xl" textAlign="center" color={headingColor}>
              Všeobecné obchodné podmienky - Snovio.sk
            </Heading>

            <Box className="bg-white p-8 rounded-lg shadow-md space-y-6">
              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  1. Všeobecné ustanovenia
                </Heading>
                <Text>
                  1.1 Tieto všeobecné obchodné podmienky (ďalej len "VOP")
                  upravujú práva a povinnosti návštevníkov webovej stránky
                  Snovio.sk (ďalej len "Používateľ") pri využívaní služieb
                  poskytovaných prostredníctvom tejto webovej stránky.
                </Text>
                <Text>
                  1.2 Prevádzkovateľom webovej stránky Snovio.sk je Smithy
                  Industries s.r.o., sídlom Ulica Jozefa Adamca 9983/24 917 01
                  Trnava (ďalej len "Prevádzkovateľ").
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  2. Popis služieb
                </Heading>
                <Text>
                  2.1 Webová stránka Snovio.sk poskytuje nasledujúce bezplatné
                  služby:
                </Text>
                <UnorderedList className="ml-6 space-y-2">
                  <ListItem>Výklad snov pomocou umelej inteligencie</ListItem>
                  <ListItem>Prístup k online snáru</ListItem>
                </UnorderedList>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  3. Používanie služieb
                </Heading>
                <Text>
                  3.1 Používanie služieb webovej stránky je bezplatné a
                  nevyžaduje registráciu.
                </Text>
                <Text>
                  3.2 Prevádzkovateľ si vyhradzuje právo na zmenu, prerušenie
                  alebo ukončenie poskytovania služieb bez predchádzajúceho
                  upozornenia.
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  4. Cookies a sledovanie
                </Heading>
                <Text>
                  4.1 Webová stránka používa službu Google Analytics na analýzu
                  návštevnosti a správania používateľov. Táto služba môže
                  zhromažďovať anonymizované údaje o:
                </Text>
                <UnorderedList as="h2" size="lg" color={headingColor}>
                  <ListItem>Vašej IP adrese (v anonymizovanej forme)</ListItem>
                  <ListItem>Type prehliadača a zariadenia</ListItem>
                  <ListItem>Čase a dĺžke návštevy</ListItem>
                  <ListItem>Navštívených stránkach</ListItem>
                </UnorderedList>
                <Text>
                  4.2 Na stránke je implementovaná služba Google AdSense na
                  zobrazovanie reklám. Táto služba používa cookies na
                  zobrazovanie relevantných reklám na základe vašich záujmov a
                  môže zhromažďovať údaje o vašom správaní pri prehliadaní.
                </Text>
                <Text>
                  4.3 Používaním našej stránky súhlasíte s používaním cookies.
                  Môžete ich zakázať v nastaveniach svojho prehliadača, čo však
                  môže obmedziť funkčnosť stránky.
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  5. Zodpovednosť
                </Heading>
                <Text>
                  5.1 Výklady snov poskytované prostredníctvom umelej
                  inteligencie majú informatívny charakter a nenahradzujú
                  odborné psychologické poradenstvo.
                </Text>
                <Text>
                  5.2 Prevádzkovateľ nezodpovedá za správnosť a úplnosť výkladov
                  snov poskytovaných prostredníctvom webovej stránky.
                </Text>
                <Text>
                  5.3 Prevádzkovateľ nezodpovedá za obsah reklám zobrazovaných
                  prostredníctvom služby Google AdSense.
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  6. Ochrana osobných údajov
                </Heading>
                <Text>
                  6.1 Webová stránka nezhromažďuje ani nespracúva osobné údaje
                  používateľov na účely registrácie.
                </Text>
                <Text>
                  6.2 Údaje zhromaždené prostredníctvom služieb Google Analytics
                  a Google AdSense sú spracúvané v súlade s pravidlami ochrany
                  osobných údajov spoločnosti Google a príslušnými právnymi
                  predpismi.
                </Text>
                <Text>
                  6.3 Používatelia majú právo odmietnuť sledovanie pomocou
                  služby Google Analytics použitím doplnku prehliadača na
                  deaktiváciu Google Analytics.
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  7. Duševné vlastníctvo
                </Heading>
                <Text>
                  7.1 Všetok obsah na webovej stránke, vrátane textov, grafiky a
                  funkcionalít, je chránený autorským právom Prevádzkovateľa.
                </Text>
              </Box>

              <Box className="space-y-4">
                <Heading as="h2" size="lg" color={headingColor}>
                  8. Záverečné ustanovenia
                </Heading>
                <Text>
                  8.1 Tieto VOP nadobúdajú platnosť a účinnosť dňom ich
                  zverejnenia.
                </Text>
                <Text>
                  8.2 Prevádzkovateľ si vyhradzuje právo na zmenu týchto VOP.
                  Zmeny nadobúdajú účinnosť dňom ich zverejnenia na webovej
                  stránke.
                </Text>
              </Box>

              <Box className="mt-8 text-sm text-gray-600">
                <Text>Posledná aktualizácia: 24.10.2024</Text>
              </Box>
            </Box>
          </VStack>
        </Container>
      </Box>
    </>
  )
}

export default Vop
